import { Button, Select, Tabs } from 'antd';
import { LoadingCommon } from '@components';
import { ExportConfirmDialog } from './components/ExportConfirmDialog';
import { NX_INTEGRATION_CONSTANT } from './constant';
import useNXIntegrationPage from './hooks/useNXIntegrationPage';
import { NXIntegrationWrapper } from './NXIntegrationPageStyled';

const { TITLE, LABEL, NOTE } = NX_INTEGRATION_CONSTANT;

function NXIntegrationPage() {
  const { state, handler } = useNXIntegrationPage();
  const {
    activeTab,
    importLog,
    yearMonthOptions,
    selectedYearMonth,
    selectedYearMonthDisplay,
    showExportDialog,
    isExporting,
    loadingPage,
  } = state;

  const statusClass =
    importLog.status === 'COMPLETE'
      ? 'nx-integration_info-value--complete'
      : importLog.status === 'ERROR'
      ? 'nx-integration_info-value--error'
      : 'nx-integration_info-value';

  const statusText =
    importLog.status === 'COMPLETE'
      ? LABEL.STATUS_COMPLETE
      : importLog.status === 'ERROR'
      ? LABEL.STATUS_ERROR
      : '—';

  const selectOptions = yearMonthOptions.map((opt) => ({
    value: opt.value,
    label: opt.label,
  }));

  // [4] Tab 1: 固定資産台帳 — read-only last auto-import info
  const tab1Content = (
    <div className="nx-integration_tab-content">
      <div className="nx-integration_import-info">
        <div className="nx-integration_info-row">
          <span className="nx-integration_info-label">
            {LABEL.IMPORT_YEAR_MONTH}
          </span>
          <span className="nx-integration_info-value">
            {importLog.importYearMonth ?? '—'}
          </span>
        </div>
        <div className="nx-integration_info-row">
          <span className="nx-integration_info-label">
            {LABEL.IMPORT_DATETIME}
          </span>
          <span className="nx-integration_info-value">
            {importLog.importDatetime ?? '—'}
          </span>
        </div>
        <div className="nx-integration_info-row">
          <span className="nx-integration_info-label">
            {LABEL.IMPORT_COUNT}
          </span>
          <span className="nx-integration_info-value">
            {importLog.recordCount != null &&
            (importLog.status === 'COMPLETE' || importLog.status === 'SUCCESS')
              ? `${importLog.recordCount.toLocaleString()} 件`
              : '—'}
          </span>
        </div>
        <div className="nx-integration_info-row">
          <span className="nx-integration_info-label">{LABEL.STATUS}</span>
          <span className={statusClass}>{statusText}</span>
        </div>
      </div>
      <p className="nx-integration_auto-import-note">{NOTE.AUTO_IMPORT}</p>
    </div>
  );

  // [5] Tab 2: 除却出力 — year/month selector + CSV export button
  const tab2Content = (
    <div className="nx-integration_tab-content">
      <div className="nx-integration_export-panel">
        <div className="nx-integration_form-item">
          <label>{LABEL.INVENTORY_YEAR_MONTH}</label>
          <Select
            size="large"
            value={selectedYearMonth}
            options={selectOptions}
            onChange={handler.handleChangeYearMonth}
            style={{ minWidth: 160 }}
          />
          <span className="nx-integration_sub-note">
            {NOTE.YEAR_MONTH_RESTRICTION}
          </span>
        </div>

        <div className="nx-integration_export-btn-row">
          <Button
            type="primary"
            size="large"
            disabled={!selectedYearMonth}
            onClick={handler.handleClickCsvOutput}
          >
            {TITLE.BTN_CSV_OUTPUT}
          </Button>
        </div>
      </div>
    </div>
  );

  const tabItems = [
    { key: 'ledger', label: TITLE.TAB_LEDGER, children: tab1Content },
    { key: 'disposal', label: TITLE.TAB_DISPOSAL, children: tab2Content },
  ];

  return (
    <LoadingCommon loading={loadingPage}>
      <NXIntegrationWrapper>
        <div className="nx-integration_header">
          <h1>{TITLE.PAGE}</h1>
        </div>

        {/* [3] Tab container — default: 固定資産台帳 */}
        <Tabs
          activeKey={activeTab}
          items={tabItems}
          onChange={handler.handleChangeTab}
        />

        {/* VAMS_PC_010_01 出力確認 dialog */}
        <ExportConfirmDialog
          open={showExportDialog}
          loading={isExporting}
          yearMonthDisplay={selectedYearMonthDisplay}
          onCancel={handler.handleCancelExportDialog}
          onOk={handler.handleConfirmExport}
        />
      </NXIntegrationWrapper>
    </LoadingCommon>
  );
}

export { NXIntegrationPage };
